import { getSchema } from '@tiptap/core';
import { DOMSerializer, Node, DOMParser } from '@tiptap/pm/model';
import { createHTMLDocument, parseHTML } from 'zeed-dom';

function getHTMLFromFragment(doc, schema) {
    const document = DOMSerializer.fromSchema(schema).serializeFragment(doc.content, {
        document: createHTMLDocument(),
    });
    return document.render();
}

function generateHTML(doc, extensions) {
    const schema = getSchema(extensions);
    const contentNode = Node.fromJSON(schema, doc);
    return getHTMLFromFragment(contentNode, schema);
}

function generateJSON(html, extensions) {
    const schema = getSchema(extensions);
    const dom = parseHTML(html);
    return DOMParser.fromSchema(schema).parse(dom).toJSON();
}

export { generateHTML, generateJSON };
//# sourceMappingURL=index.js.map
